import React from "react";

const Hero = () => {
  return (
    <div>
      <section class="hero">
        <div class="container">
          <h1>
            Hi, I'm <strong>Bhuvaneshwari Chinnadurai</strong>
          </h1>
          <p>Aspiring Full Stack Developer | IT Student | WE Scholar'23</p>
          <a href="#projects" className="btn btn-light mt-3">
            Explore Projects
          </a>
        </div>
      </section>
    </div>
  );
};

export default Hero;
